export default {
  "9142A": [
    { from: "agricFein", to: "fein" },
    { from: "agricLegalName", to: "businessName" },
    { from: "agricAddress1", to: "address1" },
    { from: "agricAddress2", to: "address2" },
    { from: "agricCity", to: "city" },
    { from: "agricState", to: "state", type: "state" },
    { from: "agricPostalCode", to: "postalCode" },
  ],
};
